<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="homebox">
      <div class="haedboximg">
        <img src="~assets/images/race/haed1.jpg" alt="" />
      </div>
      　
      <div class="racelistbox">
        <div class="rightbox">
          <div class="OneyearBox">
            <div class="monthbox">
              <div
                class="monthitem"
                v-for="month in months"
                :key="month.value"
                :data-month="month.value"
              >
                <a href="javascript:void(0)">
                  <div class="monthminbox">
                    <p>{{ month.name }}</p>
                    <div class="monthhaveraceicon" v-if="monthIsHaveRace[month.value]"></div>
                  </div>
                </a>
              </div>
            </div>

            <div class="yearbox">
              <div class="yearitem">
                <p>{{ currentYear }}年</p>
              </div>
            </div>
          </div>

          <div class="OneyearBox">
            <div class="monthbox">
              <div
                class="monthitem"
                v-for="month in months2"
                :key="month.value"
                :data-month="month.value"
              >
                <a href="javascript:void(0)">
                  <div class="monthminbox">
                    <p>{{ month.name }}</p>
                     <div class="monthhaveraceicon" v-if="month2IsHaveRace[month.value]"></div>
                  </div>
                </a>
              </div>
            </div>

            <div class="yearbox">
              <div class="yearitem">
                <p>{{ currentYear2 }}年</p>
              </div>
            </div>
          </div>
        </div>
        <div class="leftbox">
          <div class="racebox" v-for="item in raceList" :key="item.id">
            <div class="racetitle">{{ item.raceName }}</div>
            <div class="raceimg">
              <img :src="item.raceImage" alt="" />
              <!-- <img src="~assets/images/race/raceitem2.jpg" alt="" /> -->
            </div>
            <div class="racedes">
              <!-- <div class="racedes" v-html="item.raceContent"> -->
              {{ item.raceContent }}
            </div>
            <div class="raceprice">{{ item.minprice }}起</div>
            <!-- <div class="raceprice">{{ item.racePrice }}起</div> -->
            <a href="javascript:void(0)" @click="gotoRacedes(item.id)">
              <div class="racebtn">了解详情</div>
            </a>
            <div class="race-time">
              <div class="race-time-item">
                <div class="race-time-item-title">比赛时间:{{ item.raceDate }}</div>
                <div class="race-time-item-title">比赛地点:{{ item.countryName }}-{{item.cityName}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    　
    <footerBlock></footerBlock>
  </div>
</template>

<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import axios from "axios"; // 导入 Axios

export default {
  name: "racelist",
  data() {
    const currentMonth = new Date().getMonth() + 1; // 获取当前月份，注意要加1，因为getMonth()返回的是0-11
    const months = [];
    const months2 = [];
    const monthIsHaveRace=[];
    const month2IsHaveRace=[];
    // 从当前月份到12月生成月份数组
    for (let i = currentMonth; i <= 12; i++) {
      months.push({ value: i, name: `${i}月` });
      monthIsHaveRace.push(false);
    }
    for (let i = 1; i <= 12; i++) {
      months2.push({ value: i, name: `${i}月` });
      month2IsHaveRace.push(false);
    }

    return {
      showpos2: false,
      msg: "",
      months,
      months2,
      monthIsHaveRace,
      month2IsHaveRace,
      currentMonth,
      currentYear: new Date().getFullYear(), // 获取当前年份
      currentYear2: new Date().getFullYear() + 1, // 获取当前年份
      raceList: [],
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function () {
      this.$router.push({
        name: "Home",
      });
    },
    gotoRacedes: function (id) {
      // console.log(id);
      this.$router.push({
        name: "racedes",
        params: { id: id },
      });
    },

    async CheckRaceList() {
      // console.log(this.token);
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          page: 1,
          size: 10,
        };

        const url =
          "https://ttserver.aizhuotice.online/api/v1/ttRaceInfoDetails/page";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            // token: this.token,
          },
        });

        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        console.log(this.response.code);
        if (this.response.code == 200) {
          // console.log(this.response.data);
          this.raceList = this.response.data.data;

          console.log(this.raceList);
          this.raceList.forEach((element) => {
            var minprice = 999999;
            // element.raceContent = element.raceContent.replace(/<[^>]+>/g, "");
            element.raceImage = "~assets/images/race/raceitem2.jpg";
            console.log(element.imageList);
            element.imageList.forEach((element3) => {
              element.raceImage = element3.imageUrl;
            });
            element.packageList.forEach((element2) => {
              // console.log(element2.packageName + " " + element2.packagePrice);
              // console.log(
              //   element2.packagePrice +
              //     "<" +
              //     minprice +
              //     "=" +
              //     (Number(element2.packagePrice) < Number(minprice))
              // );
              if (Number(element2.packagePrice) < Number(minprice)) {
                minprice = Number(element2.packagePrice);
              }
            });
            element.minprice = minprice;
            const isoDateString = element.raceDate.replace(" ", "T");
            const dateObject = new Date(isoDateString);
            console.log(dateObject.getMonth()); 
            if(dateObject.getMonth() == 0){
              this.monthIsHaveRace[12] = true;
            }else{
              this.monthIsHaveRace[dateObject.getMonth()+1] = true;
            }
            // console.log(element.raceName + " " + element.minprice);
          });

          // console.log(this.raceList);
          // this.isShowLoginBtn = false;
        } else {
          // this.isShowLoginBtn = true;
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.CheckRaceList();
  },
  created() {},
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.homebox {
  width: 100vw;
  height: auto;
  position: relative;
}

.haedboximg {
  position: relative;
  width: 100vw;
  height: 20vw;
}

.haedboximg img {
  width: 100%;
  height: 100%;
}

.hometieboximg {
  width: 100%;
  height: 100%;
}

.hometieboximg img {
  width: 100%;
  height: 100%;
}

.hometiebtnimg {
  position: absolute;
  top: 37.5vw;
  left: 38vw;
  width: 25.5vw;
  height: 5.5vw;
}

.hometiebtnimg img {
  width: 100%;
  height: 100%;
}

.hometiebox2 {
  width: 100vw;
  height: 56.7vw;
  position: relative;
}

.racelistbox {
  position: relative;
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.rightbox {
  width: 30vw;
  height: 100%;
  background-color: #181818;
}

.OneyearBox {
  position: relative;
  width: 27vw;
  left: 3vw;
  height: auto;
  /* background-color: #000; */
  border-bottom: 4px solid #a81f24;
  /* padding-bottom: 1vw;; */
  padding-top: 0.5vw;
}

.monthbox {
  position: relative;
  width: 27vw;
  height: auto;
  font-size: 1.3vw;
  color: #fff;
  font-weight: bold;
}

.monthitem {
  position: relative;
  width: 20vw;
  height: 3.5vw;
  line-height: 3.5vw;
  padding-left: 5%;
}
.monthitem a {
  text-decoration: none;
  color: inherit;
  display: block; /* 确保 <a> 标签可以包裹内容 */
  padding-left: 80%;
}
.monthitem a:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5); /* 添加阴影 */
  background-color: #a81f24; /* 添加背景色 */
  /* text-decoration: underline;  添加下划线 */
  border-radius: 5px; /* 圆角效果 */
  transform: scale(1); /* 轻微放大 */
}
.yearbox {
  position: absolute;
  width: 20vw;
  height: 3vw;
  color: #a81f24;
  top: 2vw;
  left: 2vw;
  font-size: 3vw;
  font-weight: bold;
}

.choosemonth {
  background-color: #a81f24;
}

.leftbox {
  width: 70vw;
  height: 100%;
  background-color: #fff;
}

.racebox {
  position: relative;
  width: 55vw;
  left: 5vw;
  height: 34vw;
  /* background-color: #eee; */
  border-bottom: 1px solid #ccc;
}

.racetitle {
  position: relative;
  font-size: 2.1vw;
  font-weight: bold;
  color: #000;
  top: 2vw;
}
.raceimg {
  position: relative;
  width: 20vw;
  height: 13vw;
  top: 3vw;
  overflow: hidden; /* 超出部分隐藏 */
}

.raceimg img {
  width: auto; /* 图片宽度自适应 */
  height: 100%; /* 固定图片高度为容器高度 */
  object-fit: cover; /* 裁剪图片以保持比例 */
  display: block; /* 避免 inline 元素的默认行为 */
}
.racedes {
  position: relative;
  width: 100%;
  height: 5vw;
  font-size: 1.2vw;
  color: #000;
  top: 4vw;
}
.raceprice {
  position: relative;
  width: 100%;
  height: 2vw;
  font-size: 1.6vw;
  color: #000;
  top: 4vw;
}
.racebtn {
  position: relative;
  width: 19vw;
  height: 3vw;
  font-size: 1.6vw;
  color: #fff;
  background-color: #a81f24;
  text-align: left;
  line-height: 3vw;
  top: 5vw;
  padding-left: 1vw;
}

.race-time{
  position: absolute;
  top: 6vw;
  left:30vw;
  width: 30vw;
  height: 10vw;
  /* background-color: #eee; */
}
.race-time-item-title{
  position: relative;
  width: 100%;
  height: 5vw;
  font-size: 1.2vw;
  color: #000;
  line-height: 5vw;
  font-weight: bold;
}
.monthhaveraceicon{
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #a81f24;
  border-radius: 50%;
  top: 1.5vw;
  right: 4.5vw;
}

</style>



// WEBPACK FOOTER //
// src/components/racelist.vue